
import styled from "styled-components";
import { customProps, Flexbox } from "../../Theme/GlobalStyles";
import { globalTheme } from "../../Theme/Theme";

export const SideWrapper = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    z-index: 1999;
    overflow: hidden;
    opacity: 0;
    visibility: hidden;
    transition: 0.4s ease;

    ${({ active }) => active && `
        opacity: 1;
        visibility: visible;

        ${Overlay} {
            opacity: 1;
            visibility: visible;
        }
    `}

    .CouponWrapper{
        overflow:auto;
        max-height: calc(100% - 155px);
    }

`;

export const Overlay = styled.span.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.60);
    backdrop-filter: blur(2px);
    z-index: -1;
    opacity: 0;
    visibility: hidden;
    transition: 0.4s ease;

    ${({ disabled }) => disabled && `
        cursor: not-allowed;
    `}

`;

export const SendOfferLetterStyle = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
    position: relative;

    .feeDueWrapper {
        width: 100%;
        overflow: auto;
        min-height: calc(100vh - 160px);
    }

    .previewWrapper {
        width: 100%;
        border-radius: 10px;
        padding: 16px 16px 16px 20px;
        border: 1px solid ${globalTheme.colors.white};
        background: ${globalTheme.colors.nuetral2};
    }

    .previewBox {
        margin-top: 16px;
        width: 100%;
        border-radius: 6px;
        padding: 16px;
        border: 1px solid ${globalTheme.colors.nuetral2};
        background: ${globalTheme.colors.white1};
    }

`;

export const SideMenu = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
    position: absolute;
    right: -100%;
    top: 0;
    /* max-width: 350px; */
    max-width: ${props => props.maxWidth ? `${props.maxWidth}px` : '350px'};
    width: 100%;
    height: 100%;
    background: ${globalTheme.colors.white1};
    border-radius: 10px 0 0 10px;
    transition: 0.4s ease;

    .svg{
        width: 40px;
    }

    ${({ active }) => active && `
        right: 0;
    `}

    .ChatPreviewMode{
        background: ${globalTheme.colors.green7} !important
 }
`;

export const HeadingTop = styled(Flexbox).withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
    padding: 20px 30px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
`;

export const Body = styled(Flexbox).withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
    padding: ${props => props.padding ? props.padding : '20px 30px'};
    height:  ${props => props.height ? props.height : 'calc(100vh - 60px)'};
    
    .previewOuter{
        width: 100%;
        height:  ${props => props.height ? props.height : 'calc(100% - 41px)'};
    }

    &.LeadBody{
        overflow: auto;
    }

    .leadWrapper{
        border-radius: 10px;
        border: 1px solid ${globalTheme.colors.nuetral2};
        padding: 20px;
        min-height: calc(100vh - 110px);
    }

    .Subject{
        border-radius: 8px;
        padding: 8px 12px;
        background: ${globalTheme.colors.blue1};
        color: ${globalTheme.colors.nuetral15};
        font-size: 13px;
    }
    
    .previewContainer{
        width: 100%;
        padding: 12px ;
        border-radius: 8px;
        max-height: 485px;
        overflow: auto;
        border: 1px solid ${globalTheme.colors.nuetral2};
        background: ${globalTheme.colors.nuetral2};
    }
    .previewContainer.previewMode a {
        pointer-events: none;
        cursor: not-allowed;
        text-decoration: none;
        color: inherit;
    }



    .PreviewInner{
        border-radius: 0px 20px 20px 20px;
background: #DFFFC5;
padding: 20px;
  white-space:pre-wrap ;
    }

    .SendBtn{
        display: none;
        visibility: hidden;
        opacity: 0;
        transition: 0.4s;
        &.active{
            display: flex;
            visibility: visible;
            opacity:1;
            transition: 0.4s;
        }
    }
`;

export const ButtonContainer = styled(Flexbox).withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
    padding-top: 10px;
    border-top: 1px solid ${globalTheme.colors.nuetral2};
    width: 100%;
`;

export const SideMenuThemed = styled(SideMenu).withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
    background: ${({ theme }) => theme.primary3};
`

export const HeadingThemed = styled(HeadingTop).withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
    border-bottom: 1px solid${({ theme }) => theme.primary4};
`

export const Heading = styled(HeadingTop).withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
    border-bottom: 1px solid${({ theme }) => theme.primary4};
`
export const SideMenuFooter = styled(ButtonContainer).withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
    padding-top: 10px;
    border-top: 1px solid ${globalTheme.colors.nuetral2};
    /* width: 100%; */
    padding: 10px 30px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${globalTheme.colors.white1};
    border-top: 1px solid ${globalTheme.colors.nuetral2};
    align-items: flex-end;
    position: absolute;
    /* width: 100%; */
`